import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class JobTypeService {
    constructor(private http: HttpClient) {}

    getJobTypes() {
        return this.http.get<any>( `${environment.appOrgUrl}JobType`);
    }

    addJobType(data){
        return this.http.post<any>( `${environment.appOrgUrl}JobType`, data);
    }

    updateJobType(data){
        return this.http.put<any>( `${environment.appOrgUrl}JobType`, data);
    }

    checkJobType(jobTypeId){
        return this.http.get<any>( `${environment.appOrgUrl}JobType/AssociatedUserCheck/${jobTypeId}`);
    }

    deleteJobType(idforDelete: number, idforTransfer: number){
        return this.http.delete<any>( `${environment.appOrgUrl}JobType/${idforDelete}/${idforTransfer}`);
    }

    getAssociatedUsers(jobTypeId: number){
        return this.http.get<any>( `${environment.appOrgUrl}User/AllJobTypeUsers/${jobTypeId}`);
    }

    getUserWorkingLocation(){
        return this.http.get<any>( `${environment.appOrgUrl}Type/OrgAddress`);
    }

}